import { defineStore } from 'pinia'
import { computed, Ref, ref } from 'vue'
import api from '@app/application/client_meetings/screens/preparation/api'

import { SfLog } from '@app/adapters/logger'

export const useAssistantSuggestionsStore = defineStore(
  'assistant-talking-points-suggestions',
  () => {
    const suggestions: Ref<string[]> = ref([])
    const suggestionCount = computed(() => suggestions.value.length)
    const loadingSuggestions: Ref<boolean> = ref<boolean>(false)

    async function fetchSuggestions(): Promise<void> {
      loadingSuggestions.value = true
      try {
        const response = await api.getAISuggestions()
        suggestions.value = response ? response : []
      } catch (e) {
        SfLog.error('Error fetching AI suggestions', {
          error: e,
        })
      }

      loadingSuggestions.value = false
    }

    async function removeSuggestion(suggestion: string): Promise<void> {
      suggestions.value = suggestions.value.filter((s) => s !== suggestion)
      try {
        await api.removeAISuggestion(suggestion)
      } catch (e) {
        SfLog.error('Error removing AI suggestion', {
          error: e,
        })
      }
    }

    return {
      suggestions,
      suggestionCount,
      loadingSuggestions,
      fetchSuggestions,
      removeSuggestion,
    }
  }
)
